import React from "react";
import { Routes, Route } from "react-router-dom";

import Header from "./component/header";
import Footer from "./component/footer";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";

import Home from "./page/home";
import About from "./page/About";
import Contact from "./page/Contact";
import Gallary from "./page/gallary";
import BikeTours from "./page/BikeTours";
import TourDetail from "./page/TourDetail";
import BikeRentel from "./page/Bike-Rentel";
import CarTours from "./page/CarTours";
import TourPackage_detalis from "./page/TourPackage_detalis";
import Rental from "./page/Rental";
import Premium_Package from "./page/Premium_Package";
import Privacy_Policy from "./page/Privacy_Policy";
import Term_Condition from "./page/Term_Condition";
import { HelmetProvider } from "react-helmet-async";
import Popular from "./page/Popular";

function App() {
  return (
    <HelmetProvider>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/gallary" element={<Gallary />} />
        <Route path="/ladakh-bike-tour-packages" element={<BikeTours />} />
        {/* <Route path="/TourDetail" element={<TourDetail />} /> */}
        <Route path="/TourDetail/:slug" element={<TourDetail />} />
        <Route path="/BikeRentel" element={<BikeRentel />} />
        <Route path="/ladakh-car-tour-packages" element={<CarTours />} />
        <Route path="/TourPackage_detalis" element={<TourPackage_detalis />} />
        <Route path="/rental" element={<Rental />} />
        <Route
          path="/premium-ladakh-tour-packages"
          element={<Premium_Package />}
        />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
        <Route path="/terms-and-conditions" element={<Term_Condition />} />
       <Route path="/popular/:slug" element={<Popular />} />

      </Routes>

      <Footer />
    </HelmetProvider>
  );
}

export default App;
